import React, { useRef } from 'react';
import { createPortal } from 'react-dom';
import styled, { css } from 'styled-components';
import { theme } from '../theme';
import { Box } from '../Box';
import { IconStrict } from '../IconStrict';
import { Text } from '../Text';
import { useBodyScrollLock } from '../hooks/useBodyScrollLock';
const getDefaultTitleProps = (title) => ({
    children: title,
    tag: 'h2',
    typo: 'heading-small',
    align: 'left',
});
export const Modal = ({ title = '', children, rightPanel, showModal = false, handleClick, drawer = true, cross = true, width, containerClass, portalContainer = document.body, closeOnOverlayClick = true, }) => {
    const modalRef = useRef(null);
    useBodyScrollLock({ node: modalRef.current, showModal });
    const isTitleString = typeof title === 'string';
    const titleProps = isTitleString ? getDefaultTitleProps(title) : title;
    return createPortal(React.createElement(Wrapper, { "$showModal": showModal, ref: modalRef },
        React.createElement(Overlay, { onClick: () => closeOnOverlayClick && handleClick(), "$closeOnOverlayClick": closeOnOverlayClick }),
        React.createElement(Container, { "$drawer": drawer, "$width": width || '460px', className: containerClass },
            React.createElement(Box, { flex: true, alignItems: "flex-start", justifyContent: "space-between", mb: "8px" },
                React.createElement(TitleElements, { flex: true, direction: "column" },
                    React.createElement(Text, { ...titleProps })),
                React.createElement(Box, { flex: true, alignItems: "center", gap: '8px' },
                    rightPanel,
                    cross && (React.createElement(IconStrict, { render: "cross", title: "Close modal", backgroundColor: "oatmeal", handleClick: handleClick, size: 36 })))),
            React.createElement(Box, { flex: true, direction: "column" }, children))), portalContainer);
};
const Wrapper = styled(Box)(({ $showModal }) => css `
    display: ${$showModal ? 'flex' : 'none'};
    position: absolute;
    z-index: 999;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    justify-content: center;
    align-items: center;
  `);
const Overlay = styled.div `
  position: fixed;
  background: ${theme.colors.liquorice};
  cursor: ${(props) => (props.$closeOnOverlayClick ? 'pointer' : 'default')};
  opacity: 0.4;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
`;
const Container = styled.div(({ $drawer, $width }) => css `
    background: ${theme.colors.coconut};
    box-sizing: border-box;
    border-radius: 16px;
    padding: 24px;
    width: 100%;
    max-width: ${$width};
    position: fixed;
    max-height: calc(100vh - 64px);
    overflow: auto;
    transition: all 0.3s ease-in-out;

    ${$drawer === true &&
    css `
      @media (max-width: 768px) {
        max-width: none;
        border-radius: 16px 16px 0px 0px;
        padding: 10% 24px;
        max-height: 90vh;

        position: fixed;
        right: 0;
        left: 0;
        bottom: 0;
      }
    `}
  `);
const TitleElements = styled(Box) `
  align-self: center;
`;
//# sourceMappingURL=Modal.js.map